export default "__VITE_ASSET__e54928b6__"